class GsVideoAtelier extends HTMLElement {
  connectedCallback() {
    this.video = this.querySelector('video');
    if (!this.video || this.dataset.ready === 'true') return;

    this.dataset.ready = 'true';
    this.playButton = this.querySelector('[data-gs-video-play]');
    this.soundButton = this.querySelector('[data-gs-video-sound]');
    this.playIcon = this.querySelector('[data-gs-video-icon-play]');
    this.pauseIcon = this.querySelector('[data-gs-video-icon-pause]');
    this.mutedIcon = this.querySelector('[data-gs-video-icon-muted]');
    this.soundIcon = this.querySelector('[data-gs-video-icon-sound]');

    this.playButton?.addEventListener('click', () => this.togglePlayback());
    this.soundButton?.addEventListener('click', () => this.toggleSound());
    this.video.addEventListener('play', () => this.syncPlaybackState());
    this.video.addEventListener('pause', () => this.syncPlaybackState());
    this.video.addEventListener('volumechange', () => this.syncSoundState());

    this.syncPlaybackState();
    this.syncSoundState();

    if (this.dataset.autoplay === 'true') {
      this.video.muted = true;
      const playAttempt = this.video.play();
      if (playAttempt?.catch) playAttempt.catch(() => this.syncPlaybackState());
    }
  }

  togglePlayback() {
    if (this.video.paused) {
      const playAttempt = this.video.play();
      if (playAttempt?.catch) playAttempt.catch(() => this.syncPlaybackState());
    } else {
      this.video.pause();
    }
  }

  toggleSound() {
    this.video.muted = !this.video.muted;
  }

  syncPlaybackState() {
    const isPaused = this.video.paused;
    if (this.playIcon) this.playIcon.hidden = !isPaused;
    if (this.pauseIcon) this.pauseIcon.hidden = isPaused;
    this.playButton?.setAttribute('aria-label', isPaused ? 'Play video' : 'Pause video');
  }

  syncSoundState() {
    const isMuted = this.video.muted || this.video.volume === 0;
    if (this.mutedIcon) this.mutedIcon.hidden = !isMuted;
    if (this.soundIcon) this.soundIcon.hidden = isMuted;
    this.soundButton?.setAttribute('aria-label', isMuted ? 'Turn video sound on' : 'Mute video');
  }
}

if (!customElements.get('gs-video-atelier')) {
  customElements.define('gs-video-atelier', GsVideoAtelier);
}
